"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlbumsSecondaryNavItems = exports.getAlbumsNavItems = void 0;
require("core-js/modules/es.array.concat.js");
var _navConstants = require("../constants/navConstants");
var _insertInArrayIf = _interopRequireDefault(require("../util/insertInArrayIf"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Used in web-preauth, web-wedding
 */

var parent = _navConstants.PrimaryNavIdentifier.ALBUMS;
var businessCategory = 'ALBUM';
var businessUnit = 'PAPER';
var albumsOrdersAndDrafts = {
  title: 'Drafts and orders',
  path: '/wedding-albums/drafts',
  id: _navConstants.SecondaryNavIdentifier.ALBUMS_DRAFTS,
  parent: parent,
  businessCategory: businessCategory,
  businessUnit: businessUnit
};
var shopAlbums = {
  title: 'Shop albums',
  path: '/wedding-albums/shop',
  id: _navConstants.SecondaryNavIdentifier.ALBUMS_SHOP,
  parent: parent,
  businessCategory: businessCategory,
  businessUnit: businessUnit
};
var classicAlbums = {
  path: '/wedding-albums/select?album_type=classic',
  title: 'Classic albums',
  id: _navConstants.SecondaryNavIdentifier.ALBUMS_CLASSIC,
  parent: parent,
  businessCategory: businessCategory,
  businessUnit: businessUnit
};
var premierAlbums = {
  path: '/wedding-albums/select?album_type=premier',
  title: 'Premier albums',
  id: _navConstants.SecondaryNavIdentifier.ALBUMS_PREMIER,
  parent: parent,
  businessCategory: businessCategory,
  businessUnit: businessUnit
};
var deluxeAlbums = {
  path: '/wedding-albums/select?album_type=deluxe',
  title: 'Deluxe albums',
  id: _navConstants.SecondaryNavIdentifier.ALBUMS_DELUXE,
  parent: parent,
  businessCategory: businessCategory,
  businessUnit: businessUnit
};
var showOrdersAndDrafts = function showOrdersAndDrafts(userContext) {
  return (userContext === null || userContext === void 0 ? void 0 : userContext.has_invitation_account) && (userContext === null || userContext === void 0 ? void 0 : userContext.invitation_account) && (userContext === null || userContext === void 0 ? void 0 : userContext.invitation_account.photobooks_onboarding_completed) || false;
};
var getAlbumsSecondaryNavItems = exports.getAlbumsSecondaryNavItems = function getAlbumsSecondaryNavItems(userContext) {
  return [shopAlbums].concat(_toConsumableArray((0, _insertInArrayIf.default)(showOrdersAndDrafts(userContext), albumsOrdersAndDrafts)));
};
var getAlbumsNavItems = exports.getAlbumsNavItems = function getAlbumsNavItems(userContext) {
  return [].concat(_toConsumableArray((0, _insertInArrayIf.default)(showOrdersAndDrafts(userContext), albumsOrdersAndDrafts)), [shopAlbums, classicAlbums, premierAlbums, deluxeAlbums]);
};